import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import version from '../../package.json';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'angular.tchat';

  version = version.version;

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('');
  }
}
